<div id="cards-container" class="cards-container" [hidden]="!!entityId">
  @if (showLoader) {
    <div class="loader-container">
      <ex-overlay-loader color="secondary" [text]="'loader' | translate" />
    </div>
  }
  @if ((documentEntities && documentEntities.length > 0) || !!entityId) {
    <div class="cards-max-width" [hidden]="showLoader">
      @if (documentsType === bookmarkDocumentEntityType.ARTICLE) {
        @for (document of documentEntities; track document) {
          <app-article-card
            [isPreview]="false"
            [allowOnClick]="true"
            [docId]="document.id"
            [title]="document.title"
            [publicationDate]="document.publicationDate"
            [text]="document.excerpt"
            [source]="document.source"
            [displayBookmarkCreationDate]="true"
            [bookmarkPaths]="document.bookmarkPaths"
            [folderId]="folderId"
            [territories]="document.territories"
            [photoCount]="$safeNavigationMigration($any(document)['html']?.nbImages)"
            [showOccurrences]="false"
            [cardStyles]="{ 'border-color': 'var(--basic-300)' }"
          >
          </app-article-card>
        }
      }
      @if (documentsType === bookmarkDocumentEntityType.ADMIN_DOC) {
        @for (document of documentEntities; track document) {
          <app-admin-doc-card
            [docId]="document.id"
            [title]="document.title"
            [publicationDate]="document.publicationDate"
            [text]="document.excerpt"
            [website]="$any(document)['website']"
            [url]="$any(document)['url']"
            [showOccurrences]="false"
            [bookmarkPaths]="document.bookmarkPaths"
            [folderId]="folderId"
            [displayedPublicationType]="$any(document)['displayedPublicationType']"
            [matchStems]="$any(document)['matchStems']"
            [projectUid]="$any(document)['projectUid']"
            [cardStyles]="{ 'border-color': 'var(--basic-300)' }"
          >
          </app-admin-doc-card>
        }
      }
      @if (nbPages > 1) {
        <app-item-list-pagination
          [itemsService]="BookmarkDocumentService"
          [currentPage]="currentPage"
          [nbPages]="nbPages"
        ></app-item-list-pagination>
      }
    </div>
  } @else {
    @if (documentEntities) {
      <div class="cards-container d-flex flex-column placeholder-font padding-top-20">
        <span class="title-placeholder">{{
          (documentsType === bookmarkDocumentEntityType.ARTICLE
            ? 'folder.placeholder-no-article-title'
            : 'folder.placeholder-no-admin-doc-title'
          ) | translate
        }}</span>
        <div>
          <a class="sub-title-placeholder" routerLink="/search">{{ 'folder.placeholder-no-document-sub-title-part-1' | translate }}</a>
          <span class="sub-title-placeholder"
            >&nbsp;{{
              (documentsType === bookmarkDocumentEntityType.ARTICLE
                ? 'folder.placeholder-no-article-sub-title-part-2'
                : 'folder.placeholder-no-admin-doc-sub-title-part-2'
              ) | translate
            }}</span
          >
        </div>
      </div>
    }
  }
</div>

<section>
  <router-outlet></router-outlet>
</section>
